import { useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { useScrollToTop } from "../../useScrollToTop";
import {
  getPublicCodeDetailsRoute,
  getPublicProjectOverviewRoute,
  getPublicProjectTypesAndStandardsRoute,
} from "../../utils/routes";

interface UsePublicProjectTypeTemplateReturnData {
  backButtonProps: { text: string; onClick: () => void };
}

export const usePublicProjectTypeTemplate = (): UsePublicProjectTypeTemplateReturnData => {
  useScrollToTop();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const codeUuid = useMemo(() => {
    return searchParams.get("codeUuid");
  }, [searchParams]);

  const projectUuid = useMemo(() => {
    return searchParams.get("projectUuid");
  }, [searchParams]);

  const navigateBackToCode = (): void => {
    if (codeUuid) {
      navigate(getPublicCodeDetailsRoute(codeUuid));
    }
  };

  const navigateBackToProject = (): void => {
    if (projectUuid) {
      navigate(getPublicProjectOverviewRoute(projectUuid));
    }
  };

  const navigateBackToProjectTypesAndStandards = (): void => {
    navigate(getPublicProjectTypesAndStandardsRoute());
  };

  let backButtonProps = {
    text: "Back",
    onClick: navigateBackToProjectTypesAndStandards,
  };

  if (projectUuid) {
    backButtonProps = {
      text: "Back to project",
      onClick: navigateBackToProject,
    };
  }
  if (codeUuid) {
    backButtonProps = {
      text: "Back to code",
      onClick: navigateBackToCode,
    };
  }

  return {
    backButtonProps,
  };
};
